<div class="filter_dropdown__provider-holder" *ngIf="!isMobileFilter">
  <!-- <span class="filter_dropdown--text">{{'gamingComp.filterBy' | translate}}</span> -->
  <div class="filter_dropdown provider">
    <button class="filter_dropdown--btn filter_has_provider--btn" (click)="onFilterlistDropdown()" [ngClass]="{sorting_btn_active: filterListDropdown}">
      <span class="filter_has_provider--btn">
       {{'gamingComp.provider' | translate}}
      </span>
      <i class="icon icon-dropdown-arrow"></i>
    </button>

    <ul class="filter_dropdown__ul " [ngClass]="{active: filterListDropdown, hide: !filterListDropdown}"
      (click)="onFilterlistDropdown()">

      <li class="filter_dropdown--list-item" [ngClass]="{'active': selectedProvider === 'all' || !selectedProvider}"
        (click)="clickProviderFilter('all')">{{'gamingComp.all' | translate}}
      </li>
      <ng-container *ngFor="let provider of gameProviderMap | getValues">
        <li class="filter_dropdown--list-item" [ngClass]="{'active': providerId === provider.key}"
          (click)="clickProviderFilter(provider.key)">{{provider.val}}</li>
      </ng-container>
    </ul>
  </div>
</div>

<ul class="game_filter_dropdown--ul" *ngIf="isMobileFilter">
  <li *ngFor="let provider of gameProviderMap | getValues" (click)="clickProviderFilter(provider.key)">
    <span class="game_filter_dropdown--title" [ngClass]="{'icon-dropdown-arrow': providerId === provider.key}">{{provider.val[0]}}</span>
    <span class="game_filter_dropdown--desc">{{provider.val[1]}} {{(provider.val[1] > 1 ? 'gamingComp.games' : 'gamingComp.game') | translate }}</span>
  </li>
</ul>